import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import 'react-grid-layout/css/styles.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { persistor, store } from './configureStore';
import './common/localStorage.d';
import Preloader from './components/Preloader/Preloader';
import App from './components/App/App';
import AxiosInterceptors from './components/AxiosInterceptors/AxiosInterceptors';
import Auth0ProviderWrapper from './auth/Auth0Provider';
import {
  captureChunkReloadAttemptAtStartup,
  isStaleChunkLoadError,
  scheduleChunkReloadFlagReset,
  tryReloadForStaleChunk,
} from './common/utils/staleChunkLoadError';

captureChunkReloadAttemptAtStartup();
scheduleChunkReloadFlagReset();

if (import.meta.env.MODE !== 'development') {
  window.addEventListener('error', (event) => {
    if (isStaleChunkLoadError(event.message || event.error)) {
      tryReloadForStaleChunk(event.error ?? event.message);
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    tryReloadForStaleChunk(event.reason);
  });
}

const initializeApplication = () => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );

  root.render(
    <Provider store={store}>
      <PersistGate
        loading={<Preloader activeByDefault />}
        persistor={persistor}
      >
        <BrowserRouter>
          <Auth0ProviderWrapper>
            <AxiosInterceptors>
              <App />
            </AxiosInterceptors>
          </Auth0ProviderWrapper>
        </BrowserRouter>
      </PersistGate>
    </Provider>,
  );
};

initializeApplication();
